import React from "react";

const PromptLight = () => {
  return (
    <svg
      width="208"
      height="224"
      viewBox="0 0 208 224"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Chippy Light Icon</title>
      <rect
        x="-0.000976562"
        y="144.289"
        width="175.537"
        height="124.008"
        rx="11.325"
        transform="rotate(-50 -0.000976562 144.289)"
        fill="#EFEFEF"
      />
      <path
        d="M140.487 97.0637L134.078 96.5025C131.089 96.2409 128.453 98.4625 128.191 101.451C125.58 131.275 99.2773 153.443 69.4536 150.832C39.6299 148.221 17.5696 121.928 20.1805 92.1038L21.2895 79.437M50.2644 89.165L49.7501 95.0392C48.5603 108.63 58.8811 120.564 72.4912 121.508C85.7961 122.431 97.5486 112.612 98.8521 99.3391L100.133 86.2992M103.501 51.9986L103.781 49.1498C105.862 27.9577 90.2447 9.14244 69.0318 7.28532L67.5307 7.1539C45.6549 5.23875 26.3686 21.42 24.4535 43.2957L24.2607 45.4975"
        stroke="#434343"
        strokeWidth="13.7244"
        strokeLinecap="round"
      />
      <path
        d="M86.1714 69.0419C86.9364 60.303 94.6782 53.7983 103.512 54.5717C112.347 55.3451 118.84 63.0961 118.075 71.8349C117.31 80.5738 109.568 87.0785 100.734 86.3051C91.9001 85.5317 85.4063 77.7807 86.1714 69.0419Z"
        stroke="#434343"
        strokeWidth="13.7244"
      />
      <path
        d="M6.92567 62.1061C7.69072 53.3672 15.4325 46.8625 24.2666 47.6359C33.1008 48.4093 39.5945 56.1603 38.8295 64.8991C38.0644 73.638 30.3226 80.1427 21.4885 79.3693C12.6543 78.5959 6.16061 70.8449 6.92567 62.1061Z"
        stroke="#434343"
        strokeWidth="13.7244"
      />
      <path
        d="M39.1432 30.6071C28.0453 27.6237 17.5622 25.6096 6.92676 30.9325"
        stroke="#434343"
        strokeWidth="13.7244"
        strokeLinecap="round"
      />
      <path
        d="M91.8344 35.2247C103.282 34.2151 113.955 34.0533 123.504 41.1432"
        stroke="#434343"
        strokeWidth="13.7244"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default PromptLight;
